import classNames from 'classnames';
import { isEmpty } from 'lodash';
import React, { memo, useEffect, useRef } from 'react';
import { usePartnerMaterials } from 'src/hooks/news';

import { BANNER_TYPES } from '@sravni/react-advertisement';
import { useIsMobile, useTheme } from '@sravni/react-utils';

import { SravniNewsSharedModelsMaterialsHighLight } from '../../__generated__/news/Api';
import { ReduxBanner } from '../../components/ReduxBanner';
import { AB_NAME } from '../../constants/sitesettings';
import { TBannersList } from '../../interfaces/advertising';
import { THighLight, TPartnerMaterial } from '../../interfaces/news';
import { ReadingNowWidget } from '../ReadingNowWidget';
import { ReadOnBlock } from '../ReadOnBlock';

import styles from './right-column.module.scss';

export interface IRightColumnProps {
  banners?: TBannersList;
  readOnBlockMaterials?: (SravniNewsSharedModelsMaterialsHighLight & TPartnerMaterial)[];
  readOnBlockTitle?: string;
  isLoadingBanners?: boolean;
  isAdsHidden?: boolean;
}

export const RightColumnContent = memo<IRightColumnProps>(
  ({
    readOnBlockTitle,
    isLoadingBanners,
    banners,
    readOnBlockMaterials: propsReadOnBlockMaterials,
    isAdsHidden = false,
  }) => {
    const isMobile = useIsMobile();
    const [theme] = useTheme();
    const rightColumnRef = useRef<HTMLDivElement>(null);

    const partnerMaterials = usePartnerMaterials();
    const readOnBlockMaterials =
      propsReadOnBlockMaterials ||
      (!isEmpty(partnerMaterials) &&
        (Object.values(partnerMaterials)?.slice(0, 3) as (TPartnerMaterial & THighLight)[]));

    useEffect(() => {
      const searchIframes = rightColumnRef.current?.getElementsByTagName('iframe');

      if (searchIframes) {
        Array.from(searchIframes).forEach((iframe) => {
          try {
            if (iframe.contentDocument.querySelector('iframe')) {
              iframe.contentWindow.postMessage(
                // Serialize the message
                JSON.stringify({
                  event: 'changeThemeIframe',
                  theme: theme,
                }),
                '*',
              );
            }
          } catch {}
        });
      }
    }, [theme, rightColumnRef]);

    return (
      <div className={styles.wrapper} ref={rightColumnRef}>
        <div className={styles.stickyBlock}>
          {!isMobile && (
            <div className={classNames(styles.sideBanner, 'h-pb-24')}>
              {isAdsHidden ? (
                <ReadingNowWidget />
              ) : (
                <ReduxBanner
                  lazy={true}
                  banner={banners?.[BANNER_TYPES.SIDE]}
                  type={BANNER_TYPES.SIDE}
                  className={styles.sideBanner}
                  abName={AB_NAME}
                  isLoading={isLoadingBanners}
                />
              )}
            </div>
          )}
          {!!readOnBlockMaterials?.length && (
            <ReadOnBlock readOnBlockMaterials={readOnBlockMaterials} readOnBlockTitle={readOnBlockTitle} />
          )}
        </div>
      </div>
    );
  },
);
